<template>
    
    <div>
        
        <div class="header">
            <h1><div :class="{ loading }" v-if="loading">loading</div><div v-else>ready, steady</div></h1>
            <span class="last_updated">last updated: <span v-if="last_updated_date_object">{{ last_updated_date_object | dateFormat('DD.MM.YYYY HH:mm:ss') }}</span></span>
        </div>

        <v-container fluid>

            <v-row align="center" no-gutters>
                <v-col cols="3">
                </v-col>
                <v-col cols="3">
                        <v-switch  class="auto_update"
                        v-model="auto_update"
                        >
                        {{ loading }}
                        <template v-slot:label>
                    Auto-update<v-progress-circular
                    :indeterminate="loading"
                    size="24"
                    class="ml-2"
                    ></v-progress-circular>
                </template></v-switch>
                </v-col>

                <v-col cols="2">
                    <v-select
                    @change="onSelectChange"
                    v-model="sorting"
                    :items="sortOptions"
                    item-text="name"
                    item-value="option"
                    label="Sorting"
                    persistent-hint
                    return-object
                    single-line
                    prepend-icon="mdi-sort"
                    ></v-select>
                </v-col>

                <v-col cols="4">
                </v-col>
      
            </v-row>
        </v-container>

        <Caroussel 
            v-if="images"
            :images="images"
            :displayMode="displayMode"
        />
        
        <div class="list-view">
        <stack 
              :column-min-width="300"
              :gutter-width="5"
              :gutter-height="5"
              monitor-images-loaded
        >
        
            <stack-item
                    v-for="(image, i) in images"
                    :key="i"
                    style="transition: transform 300ms"
            >
                <div class="block" >

                    <div class="image"  @click="showSingle(image)">
                        <img :src="image.gallery" :alt="image.title" />
                    </div>

                    <div class="meta">

                    <div class="meta-footer">
                        <div class="meta-score">
                            {{ image.votes_count }} <span>{{ image.votes_count + 90 }}</span>
                        </div>
                        <div class="meta-icons">
                            <Icons next
                                v-bind:image="image"
                            />
                        </div>
                    </div>
                 
                     <div class="meta-header">
                        <p><strong>{{ image.title }}</strong> by <router-link :to="{ name: 'user-gallery', params: { id: image.user }}">{{ image.user }}</router-link></p>
                    </div>
                    </div>
                </div>
            </stack-item>
        
        </stack>
        </div>
    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import { Stack, StackItem } from "vue-stack-grid";
    import Icons from '@/components/gallery/Icons'
    import Caroussel from '@/components/gallery/Caroussel'
    import { userMixin, imageMixin } from '@/functions/mixins'

    export default {
        name: 'Gallery',
        components: { 
            Stack, 
            StackItem,
            Icons,
            Caroussel
        },
        mixins: [userMixin, imageMixin],
        props: ['display-mode'],
        data() {
            return {
                id: this.$route.params.id,
                options: {
                    width: 300,
                    padding: {
                        2: 8,
                        default: 12
                    },
                },
                sortOptions: [
                    {
                        name: 'latest',
                        option: 'added'
                    },
                    {
                        name: 'popular',
                        option: 'votes_count'
                    }
                ],
                sorting: 'added',
                auto_update: false,
                update_timer: null,
                last_updated_date_object: null,
            }
        },
        computed: {
            ...mapState({
                 last_updated: state => state.user.last_updated
            }),
            images () {
                let images = []
                if ( this.id && this.$route.name == 'user-gallery' ) images = this.filteredByUser(this.id)
                if ( this.id && this.$route.name == 'collective-gallery' ) images = this.filteredByCollective(this.id)
                if ( this.id && this.$route.name == 'project-gallery' ) images = this.filteredByProject(this.id)
                if ( !this.id ) images = this.filteredByAll
                images = this.sortImages(images)
                return images
            }
        },
        watch: {
            id: function() {
                this.getImages()
            },
            sorting: function() {
                this.current = 0
                this.getImages()
            },
            auto_update: function() {
                this.setAutoUpdate()
            },
            last_updated: function() {
                this.last_updated_date_object = new Date(this.last_updated)
            }
        },
        methods: {
            onSelectChange(select) {
                this.sorting = select.option
            },
            sortImages(images) {
                if ( this.sorting == 'votes_count' ) {
                    images.sort((a,b) => b.votes_count - a.votes_count)
                } else if ( this.sorting == 'added' ) {
                    images.sort((a,b) => b.pk - a.pk)
                }
                return images
            },
            getImages(params = {}) {
                params.sorting = this.sorting
                if( this.id && this.$route.name == 'user-gallery' ) params.user = this.id
                if( this.id && this.$route.name == 'collective-gallery' ) params.collective = this.id
                params.route = this.$route.path
                this.loading = true
                this.$store.dispatch('image/getImages', params).finally(() => (this.loading=false));
            
            },
            
            showSingle(image) {
                this.$router.push({ name: 'image', params: { id: this.username, image_id: image.pk } }).catch(()=>{});           
            },
            setAutoUpdate() {
                if(this.auto_update == true) {
                    this.getImages()
                    this.update_timer = window.setInterval(() => {
                    this.getImages()
                    this.$forceUpdate();
                }, 30000);
                } else {
                    clearInterval(this.update_timer);
                }
            },
            
        },
        mounted() {
            this.getImages()
        },
        created() {
            this.loading = false,
            this.$watch(
                () => this.$route.params,
                (toParams) => {
                    this.id = toParams.id
                }
            )
        },
                     
    }
</script>

<style lang="scss">

.header {
    padding-top: 25px;
}

.meta-icons {
    float: right;
}

img {
    object-fit: cover;
    width: 100%;
    height: auto;
    line-height: 0;
    display: block;
}

.loading {
    color: orange;
}

.last_updated {
        font-size: 75%;
    }

.profile-header {
    .display-mode {
        color: orange;
    }
    font-size: 150%;
    font-weight:bold;
    text-align:left;
    .display-name {
        color: purple;
    }
}

.auto_update {
    width: 200px;
    margin-left: calc(50% - 150px/2)
}

.sorting {

        list-style: none;
        display: inline;
        padding: 0;
        margin: 0;

        li {
            // &:after { content: " | "; }
            // &:last-child:after { content: ""; }
            padding: 0;
            padding-right: 10px;
            margin: 0;
            display: inline;
            text-decoration: underline;
            cursor: pointer;
            &.active {
                color: purple;
                font-weight: bold;
            }
        }

    
}

.block {

    // pointer-events:none;

    img {
        // pointer-events:auto;
        &:hover {
            cursor: pointer;
        }
    }

    a {
        color: white;
        font-weight: bold;
    }

    i.v-icon.v-icon {
        color: orange;
        background-color: wheat;
        margin: 5px 5px 10px 0px;
        font-size: 20px;
    } 

    .meta {
        visibility: hidden;

        .meta-header {
            &::before { content: '\A'; white-space: pre; }
            padding-top: 20px;
            text-align: left;
            color: white;

        }

        .meta-footer {
            position:relative;
            margin-top: -30px;
            

            .meta-icons {
                position: absolute;
                background: #272727;
                height: auto;
                color: white;
                font-weight: bold;
                padding-left: 5px;
                right:0;
             
                display: inline-block;
            }
            .meta-score {
                position: absolute;
                background: white;
                height: auto;
                color: black;
                font-weight: bold;
                padding: 1px 0px 0px 5px;
                left:0;
                margin-top: 5px;
                span {
                    background: orange;
                    padding: 4px;
                }
            }
        }

    }
    

    padding: 15px 15px 1px 15px;
    background-color: wheat;
    height: 100%;

    &:hover {
        background-color: #272727;

        i.v-icon.v-icon {
            background-color: #272727;
            &.invert {
                background-color: orange;
                color: #272727;
            }
        } 

        .meta {
            visibility: visible;

           
        }

    }
    
  
}

.carousel-view {

    a {
        color: white;
        font-weight: bold;
    }



    .image-container {
        position: relative;
        left: 0px;  /* stick it wherever it was positioned by default */
        top: 0px;
    }

    .meta {
        position: absolute;;
        background-color: #272727;
        padding: 10px 10px 10px 0px;
        width: 250px;
        right:0;
        top:0;
        color: white;

         .meta-score {

                float:left;
                background: white;
                height: inherit;
                color: black;
                font-weight: bold;
                padding: 1px 0px 0px 5px;
                left:0;
                bottom: 0;
                span {
                    background: orange;
                    padding: 4px;
                }
            }

    }
    .navigation {
        position: absolute;;
        background-color: #272727;
        padding: 10px;
        width: 250px;
        right:0;
        bottom:0;
        color: white;
        cursor: pointer;
    }
     i.v-icon.v-icon {
        font-size: 150%;
        margin-top:10px;
        margin-left: 5px;
        color: white;
    } 
}

@media only screen and (max-width: 900px) {

    .header {
        padding-top: 0px;
        margin-top: 0px;
    }

    h1 {
        font-size: 150%;
    }

}

</style>

<style lang="scss">

@media only screen and (max-width: 700px) {

    .carousel-view {
        display: none;
    }

    .block {

        .meta {

            .meta-header {
                padding-top: 0px;
            }

            .meta-footer {
                position:relative;
                margin-top: 0px;

                .meta-icons {
                    position: fixed;
                    background: #272727;
                    height: auto;
                    color: white;
                    font-weight: bold;
                    padding-left: 5px;
                    top: 40%;
                    left: calc(50% - 150px/2);
                    width: 150px;
                    display: inline-block;

                     i.v-icon.v-icon {
                        font-size: 250%;
                    } 

                }
                .meta-score {
                float:left;
                background: white;
                height: inherit;
                color: black;
                font-weight: bold;
                padding: 1px 0px 0px 5px;
                left:0;
                bottom: 0;
                span {
                    background: orange;
                    padding: 4px;
                }
                }
            }
        }
    }

}

</style>
